import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

// ── Category header config ─────────────────────────────────────────────────
const CATEGORY_CONFIG = [
  { keys: ['electron'],                        colors: ['#1565C0', '#1976D2'], emoji: '📱' },
  { keys: ['fashion', 'cloth', 'wear', 'apparel'], colors: ['#388E3C', '#43A047'], emoji: '👗' },
  { keys: ['health'],                          colors: ['#AD1457', '#D81B60'], emoji: '💊' },
  { keys: ['beauty', 'cosmetic'],              colors: ['#7B1FA2', '#8E24AA'], emoji: '💄' },
  { keys: ['food'],                            colors: ['#BF360C', '#E64A19'], emoji: '🍔' },
  { keys: ['beverage', 'drink'],               colors: ['#E65100', '#EF6C00'], emoji: '☕' },
  { keys: ['sport'],                           colors: ['#00695C', '#00796B'], emoji: '⚽' },
  { keys: ['outdoor'],                         colors: ['#2E7D32', '#388E3C'], emoji: '🏕️' },
  { keys: ['home', 'furniture'],               colors: ['#4E342E', '#6D4C41'], emoji: '🏠' },
  { keys: ['garden'],                          colors: ['#558B2F', '#689F38'], emoji: '🌿' },
  { keys: ['auto', 'vehicle', 'car'],          colors: ['#37474F', '#455A64'], emoji: '🚗' },
  { keys: ['real', 'estate', 'property', 'land'], colors: ['#1A237E', '#283593'], emoji: '🏢' },
  { keys: ['job', 'career', 'hire'],           colors: ['#006064', '#00838F'], emoji: '💼' },
  { keys: ['service'],                         colors: ['#0277BD', '#0288D1'], emoji: '🔧' },
  { keys: ['education', 'school', 'learn', 'book'], colors: ['#1565C0', '#1976D2'], emoji: '📚' },
  { keys: ['animal', 'pet'],                   colors: ['#2E7D32', '#33691E'], emoji: '🐾' },
  { keys: ['art', 'collect'],                  colors: ['#4527A0', '#512DA8'], emoji: '🎨' },
]
const DEFAULT_CFG = { colors: ['#546E7A', '#607D8B'], emoji: '🏷️' }

const getCategoryCfg = (name = '') => {
  const n = name.toLowerCase()
  return CATEGORY_CONFIG.find(c => c.keys.some(k => n.includes(k))) || DEFAULT_CFG
}

// ── Subcategory → Icons8 image URL ────────────────────────────────────────
const SUBCATEGORY_ICONS = [
  // Electronics
  { keys: ['smartphone', 'phone', 'mobile'], name: 'smartphone' },
  { keys: ['laptop', 'notebook', 'computer'], name: 'laptop' },
  { keys: ['tv ', 'television'], name: 'tv' },
  { keys: ['camera'], name: 'camera' },
  { keys: ['headphone', 'audio', 'speaker', 'earphone', 'airpod'], name: 'headphones' },
  { keys: ['gaming', 'console', 'playstation', 'xbox'], name: 'game-controller' },
  { keys: ['tablet', 'ipad'], name: 'tablet' },
  { keys: ['printer'], name: 'print' },
  // Fashion
  { keys: ["women's", 'female', 'lady', 'girl'], name: 'women-age-group-4' },
  { keys: ["men's", 'male', 'man', 'boy'], name: 'men-age-group-4' },
  { keys: ['kids', 'children', 'baby', 'toddler'], name: 'baby-feet' },
  { keys: ['shoe', 'sneaker', 'boot', 'sandal', 'footwear'], name: 'sneakers' },
  { keys: ['bag', 'handbag', 'purse', 'backpack'], name: 'purse' },
  { keys: ['watch'], name: 'watch' },
  { keys: ['dress', 'skirt', 'gown'], name: 'dress' },
  { keys: ['accessories', 'jewel', 'bracelet'], name: 'jewel' },
  // Health & Beauty
  { keys: ['skincare', 'face cream', 'moisturizer', 'serum'], name: 'face-cream' },
  { keys: ['makeup', 'lipstick', 'cosmetic', 'foundation'], name: 'lipstick' },
  { keys: ['hair'], name: 'hair-dryer' },
  { keys: ['vitamin', 'pill', 'supplement', 'capsule'], name: 'pill' },
  { keys: ['fitness', 'gym', 'workout', 'dumbbell'], name: 'dumbbell' },
  { keys: ['medical', 'medicine', 'stethoscope', 'hospital'], name: 'stethoscope' },
  // Food
  { keys: ['fresh', 'vegetable', 'fruit', 'produce'], name: 'salad' },
  { keys: ['packaged', 'grocery', 'snack', 'chip'], name: 'popcorn' },
  { keys: ['beverage', 'drink', 'water', 'juice'], name: 'water-bottle' },
  { keys: ['organic', 'natural'], name: 'organic-food' },
  { keys: ['catering', 'restaurant', 'meal'], name: 'meal' },
  // Sports
  { keys: ['football', 'soccer'], name: 'football' },
  { keys: ['basketball'], name: 'basketball' },
  { keys: ['camp', 'tent', 'hike', 'trek'], name: 'camping-tent' },
  { keys: ['cycling', 'bike', 'bicycle'], name: 'cycling' },
  { keys: ['swimming', 'pool'], name: 'swimmer' },
  { keys: ['exercise', 'equipment', 'weight', 'training'], name: 'dumbbell' },
  // Home
  { keys: ['sofa', 'couch', 'chair', 'furniture'], name: 'sofa' },
  { keys: ['kitchen', 'cooking', 'utensil', 'pot'], name: 'restaurant' },
  { keys: ['bed', 'bedding', 'mattress', 'pillow'], name: 'bed' },
  { keys: ['garden', 'plant', 'flower'], name: 'potted-plant' },
  { keys: ['lighting', 'lamp', 'bulb'], name: 'floor-lamp' },
  { keys: ['decor', 'decoration', 'curtain'], name: 'vase' },
  // Automotive
  { keys: ['car', 'sedan', 'suv', 'jeep'], name: 'car' },
  { keys: ['motorcycle', 'motor', 'okada'], name: 'motorcycle' },
  { keys: ['truck', 'van', 'bus', 'lorry'], name: 'truck' },
  { keys: ['spare', 'part', 'engine', 'tyre', 'tire'], name: 'engine' },
  // Real Estate
  { keys: ['house', 'bungalow', 'duplex'], name: 'home' },
  { keys: ['apartment', 'flat', 'studio', 'condo'], name: 'building' },
  { keys: ['land', 'plot'], name: 'land' },
  { keys: ['commercial', 'office', 'shop'], name: 'skyscraper' },
  { keys: ['short let', 'rental', 'rent'], name: 'key' },
  // Jobs
  { keys: ['full-time', 'fulltime', 'permanent'], name: 'businessman' },
  { keys: ['part-time', 'parttime'], name: 'part-time' },
  { keys: ['freelance', 'remote', 'contract'], name: 'freelancer' },
  { keys: ['intern', 'graduate', 'entry'], name: 'student-male' },
  { keys: ['service', 'professional'], name: 'maintenance' },
  // Education
  { keys: ['tutoring', 'tutor', 'lesson', 'teacher'], name: 'teacher' },
  { keys: ['online', 'course', 'e-learning'], name: 'online-learning' },
  { keys: ['book', 'textbook', 'stationery'], name: 'book' },
  { keys: ['school', 'university', 'college'], name: 'school' },
  // Animals
  { keys: ['dog', 'puppy', 'canine'], name: 'dog' },
  { keys: ['cat', 'kitten', 'feline'], name: 'cat' },
  { keys: ['bird', 'parrot', 'chicken'], name: 'parrot' },
  { keys: ['fish', 'aquarium'], name: 'tropical-fish' },
  { keys: ['pet food', 'collar', 'bone'], name: 'dog-bone' },
  // Art
  { keys: ['painting', 'canvas', 'artwork'], name: 'painting-palette' },
  { keys: ['photography', 'photo'], name: 'camera' },
  { keys: ['jewelry', 'ring', 'necklace', 'earring', 'diamond'], name: 'diamond' },
  { keys: ['antique', 'vintage', 'collectible'], name: 'vase' },
  { keys: ['craft', 'sewing', 'knitting'], name: 'sewing' },
]

const getSubIconUrl = (subName) => {
  const n = subName.toLowerCase()
  for (const item of SUBCATEGORY_ICONS) {
    if (item.keys.some(k => n.includes(k))) {
      return `https://img.icons8.com/color/48/${item.name}.png`
    }
  }
  return null
}

const lightenHex = (hex) => {
  const num = parseInt(hex.replace('#', ''), 16)
  const r = Math.min(255, ((num >> 16) & 0xff) + 80)
  const g = Math.min(255, ((num >> 8) & 0xff) + 80)
  const b = Math.min(255, (num & 0xff) + 80)
  return `rgb(${r},${g},${b})`
}

// ── Subcategory icon (responsive + skeuomorphic) ──────────────────────────
const SubIcon = ({ subName, emoji, colorA, colorB }) => {
  const url = getSubIconUrl(subName)
  const [imgFailed, setImgFailed] = React.useState(false)
  const showImg = url && !imgFailed

  return (
    <div
      className="w-9 h-9 sm:w-7 sm:h-7 rounded-xl sm:rounded-lg flex items-center justify-center relative overflow-hidden shrink-0"
      style={showImg
        ? { background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.10), inset 0 1px 0 rgba(255,255,255,0.9)', border: '1px solid rgba(0,0,0,0.06)' }
        : { background: `linear-gradient(145deg, ${lightenHex(colorA)}, ${colorB})`, boxShadow: '0 2px 6px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.35)' }
      }
    >
      {showImg ? (
        <>
          <div className="absolute inset-x-0 top-0 h-1/2 pointer-events-none" style={{ background: 'rgba(255,255,255,0.15)' }} />
          <img
            src={url}
            alt={subName}
            className="w-6 h-6 sm:w-5 sm:h-5 object-contain relative z-10"
            onError={() => setImgFailed(true)}
          />
        </>
      ) : (
        <>
          <div className="absolute inset-x-0 top-0 h-1/2 pointer-events-none" style={{ background: 'rgba(255,255,255,0.25)' }} />
          <span className="text-sm sm:text-xs leading-none relative z-10">{emoji}</span>
        </>
      )}
    </div>
  )
}

// ── Category card (skeuomorphic · responsive) ────────────────────────────
const CategoryCard = ({ category }) => {
  const { colors, emoji } = getCategoryCfg(category.name)
  const [colorA, colorB] = colors
  const subs = category.subcategories || []
  const displaySubs = subs.slice(0, 4)
  const extraCount = subs.length - displaySubs.length

  return (
    <div
      className="rounded-2xl sm:rounded-xl overflow-hidden flex flex-col"
      style={{
        background: 'linear-gradient(180deg, #ffffff 0%, #f9fafb 100%)',
        boxShadow: '0 6px 20px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.9)',
        border: '1px solid rgba(0,0,0,0.07)',
      }}
    >
      {/* Glossy 3D header */}
      <Link
        to={`/products?category=${category.name}`}
        className="relative flex items-center gap-2 px-3 sm:px-2.5 overflow-hidden"
        style={{
          height: '44px',
          background: `linear-gradient(160deg, ${colorA} 0%, ${colorB} 100%)`,
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.28), inset 0 -2px 4px rgba(0,0,0,0.18)',
        }}
      >
        <div className="absolute inset-x-0 top-0 pointer-events-none" style={{ height: '55%', background: 'linear-gradient(180deg, rgba(255,255,255,0.28) 0%, rgba(255,255,255,0) 100%)' }} />
        <div className="absolute top-0 inset-x-0 h-px pointer-events-none" style={{ background: 'rgba(255,255,255,0.45)' }} />
        <div className="absolute bottom-0 inset-x-0 h-px pointer-events-none" style={{ background: 'rgba(0,0,0,0.18)' }} />
        {/* Frosted emoji badge */}
        <div
          className="w-7 h-7 sm:w-6 sm:h-6 rounded-xl sm:rounded-lg flex items-center justify-center shrink-0 relative z-10"
          style={{ background: 'rgba(255,255,255,0.22)', boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.4), 0 1px 3px rgba(0,0,0,0.18)', backdropFilter: 'blur(4px)' }}
        >
          <span className="text-base sm:text-sm leading-none">{emoji}</span>
        </div>
        <span className="text-white font-bold text-[13px] sm:text-[11px] truncate relative z-10" style={{ textShadow: '0 1px 2px rgba(0,0,0,0.25)' }}>
          {category.name}
        </span>
      </Link>

      {/* 2×2 subcategory grid */}
      <div className="grid grid-cols-2 gap-1.5 sm:gap-1 p-2.5 sm:p-1.5 flex-grow">
        {displaySubs.length > 0 ? (
          displaySubs.map((sub, i) => (
            <Link
              key={i}
              to={`/products?category=${category.name}&subcategory=${sub}`}
              className="flex flex-col items-center text-center gap-1 sm:gap-0.5 rounded-lg p-1.5 sm:p-1 transition-all hover:bg-gray-50 active:scale-[0.97]"
            >
              <SubIcon subName={sub} emoji={emoji} colorA={colorA} colorB={colorB} />
              <span className="text-[10px] sm:text-[8px] font-medium leading-tight text-gray-700 line-clamp-2 w-full">{sub}</span>
            </Link>
          ))
        ) : (
          <div className="col-span-2 flex items-center justify-center text-[11px] sm:text-[10px] text-gray-400 py-3 sm:py-2">
            Browse listings
          </div>
        )}
        {extraCount > 0 && (
          <Link
            to={`/products?category=${category.name}`}
            className="flex flex-col items-center text-center gap-1 sm:gap-0.5 rounded-lg p-1.5 sm:p-1 hover:bg-gray-50 transition-all"
          >
            <div
              className="w-9 h-9 sm:w-7 sm:h-7 rounded-xl sm:rounded-lg flex items-center justify-center"
              style={{ background: 'linear-gradient(145deg, #e5e7eb, #d1d5db)', boxShadow: '0 2px 6px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.5)' }}
            >
              <span className="text-[10px] sm:text-[8px] font-bold text-gray-500">+{extraCount}</span>
            </div>
            <span className="text-[10px] sm:text-[8px] font-medium text-gray-500">more</span>
          </Link>
        )}
      </div>

      {/* Gold View Listings button */}
      <div className="px-2.5 sm:px-1.5 pb-2.5 sm:pb-1.5 pt-1 border-t border-gray-100 mt-auto">
        <Link
          to={`/products?category=${category.name}`}
          className="w-full rounded-xl sm:rounded-lg py-1.5 sm:py-1 text-[11px] sm:text-[10px] font-bold text-center block transition-all active:scale-95 hover:brightness-95"
          style={{
            background: 'linear-gradient(160deg, #FFE8B3, #FFCF5C)',
            color: '#7C4D00',
            boxShadow: '0 2px 6px rgba(255,180,0,0.25), inset 0 1px 0 rgba(255,255,255,0.5)',
            border: '1px solid rgba(255,180,0,0.25)',
          }}
        >
          View Listings →
        </Link>
      </div>
    </div>
  )
}

// ── Main export ────────────────────────────────────────────────────────────
const Categorys = () => {
  const { categorys } = useSelector(state => state.home)

  return (
    <div className="max-w-7xl w-[92%] mx-auto">
      <div className="grid grid-cols-4 lg:grid-cols-3 md-lg:grid-cols-2 gap-3 sm:gap-2">
        {categorys.map((c, i) => (
          <CategoryCard key={i} category={c} />
        ))}
      </div>
    </div>
  )
}

export default Categorys
